"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/polyfill/lib/noConflict.js
// module id = 160
// module chunks = 0